export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const RESET_AUTH = 'RESET_AUTH';
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const SET_AUTH_SUCCESS = 'SET_AUTH_SUCCESS';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_STATE = 'CLEAR_STATE';
export const UPDATE_PAYMENT_STATUS = 'UPDATE_PAYMENT_STATUS';
